// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["applicationVendors-node_modules_hotwired_turbo-rails_app_javascript_turbo_fetch_requests_js-n-a05501"], () => (__webpack_require__("./app/javascript/application.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["applicationVendors-node_modules_hotwired_turbo-rails_app_javascript_turbo_fetch_requests_js-n-a05501"], () => (__webpack_require__("./app/javascript/application.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
